import SEO from "../components/SEO";
import { motion } from "framer-motion";
import { CheckCircle, Calendar, ArrowRight } from "lucide-react";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_5ead2d97-7ad4-48d6-8ee4-b13556106f69/artifacts/jd65gb5i_CityWorth%20Logo.png";

// ============================================
// ZOOM LINK - UPDATE THIS WHEN CHANGING WEBINAR
// ============================================
const ZOOM_WEBINAR_LINK = "https://zoom.us/webinar/register/WN__fC109gdSYC3mFsF8cBJJA";
// ============================================

const ThankYouPage = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-slate-50"
      data-testid="thank-you-page"
    >
      {/* Navigation */}
      <nav className="bg-white border-b border-slate-200">
        <div className="container-main flex items-center justify-between py-4">
          <Link to="/">
            <img src={LOGO_URL} alt="CityWorth" className="h-10" />
          </Link>
        </div>
      </nav>

      <div className="container-main py-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="max-w-2xl mx-auto text-center"
        >
          <div className="bg-white rounded-2xl p-12 shadow-sm border border-slate-200">
            <div className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
              <CheckCircle className="w-10 h-10 text-green-500" />
            </div>
            
            <h1 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Thank You!
            </h1>
            
            <p className="text-lg text-slate-600 mb-8">
              We've received your information and will be in touch shortly to discuss how CityWorth can help your organization implement a Homeownership Employee Benefit.
            </p>

            <div className="bg-slate-50 rounded-xl p-6 mb-8">
              <div className="flex items-center justify-center gap-2 mb-3">
                <Calendar className="w-5 h-5 text-red-500" />
                <span className="font-semibold text-slate-900">Don't Miss Our Next Event!</span>
              </div>
              <p className="text-slate-600 mb-4">
                Join us for <strong>The Big Shift</strong> — a live webinar on why homeownership is becoming the next major employee benefit.
              </p>
              {/* ZOOM LINK BUTTON - Goes directly to Zoom registration */}
              <a href={ZOOM_WEBINAR_LINK} target="_blank" rel="noopener noreferrer">
                <Button className="btn-primary text-white">
                  Register for The Big Shift
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </a>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/">
                <Button variant="outline" className="border-slate-300">
                  Return to Home
                </Button>
              </Link>
              <Link to="/events">
                <Button variant="outline" className="border-slate-300">
                  View All Events
                </Button>
              </Link>
            </div>
          </div>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default ThankYouPage;
